import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IMarker } from '../../types/interfaces';

const initialState: any = {
  allAccess: Array<IMarker>(),
};

export const accessSlice = createSlice({
  name: 'accessSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateAccess: (state, action) => {
      state.allAccess = action.payload;
    },
  },
});

export const { updateAccess } = accessSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const accessState = (state: RootState) => state.access.allAccess;

export default accessSlice.reducer;
